import { useCallback, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import './styles/styles.scss';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Play from './pages/Play';
import Result from './pages/Result';
import { playRound } from './game';

const INITIAL_SCORE = { player: 0, computer: 0 };

function App() {
  const [score, setScore] = useState(INITIAL_SCORE);
  const [round, setRound] = useState(null);

  const play = useCallback((choiceName) => {
    const result = playRound(choiceName);

    setRound(result);
    setScore((prev) => ({
      player: prev.player + (result.outcome === 'win' ? 1 : 0),
      computer: prev.computer + (result.outcome === 'loss' ? 1 : 0),
    }));
  }, []);

  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Play" element={<Play score={score} onPlay={play} />} />
        <Route path="/Res" element={<Result score={score} round={round} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
